// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-container {
  margin: 1rem 0;
}

.progress-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #555;
}

.progress-bar {
  height: 12px;
  background: #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: var(--button-color, #007bff);
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-fill.warning {
  background: #ffc107;
}

.progress-fill.danger {
  background: #dc3545;
}

.progress-percentage {
  font-size: 0.8rem;
  color: #666;
  text-align: right;
  margin-top: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Consumption/ProgressBar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".progress-container {\n  margin: 1rem 0;\n}\n\n.progress-label {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.progress-bar {\n  height: 12px;\n  background: #e9ecef;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: var(--button-color, #007bff);\n  border-radius: 6px;\n  transition: width 0.3s ease;\n}\n\n.progress-fill.warning {\n  background: #ffc107;\n}\n\n.progress-fill.danger {\n  background: #dc3545;\n}\n\n.progress-percentage {\n  font-size: 0.8rem;\n  color: #666;\n  text-align: right;\n  margin-top: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
